module.exports = __webpack_public_path__ + "f443aedfcdbd9684ea74d30802ef880d.svg";